import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";
import { toast } from "react-toastify";

export const updateEmployeeRole = createAsyncThunk('getRolePermission/updateEmployeeRole',
  async ({userId,roleId}, { rejectWithValue }) => {
    console.log('userId,roleId')
    try {
      const response = await axiosPrivate.post(
        `${api.updateEmployeeRole}userId=${userId}&roleId=${roleId}`, 
        {} 
      );
       if (response.data.success === true) {
              toast.success(response.data.reason, {
                className: "toast-success-custom",
              });
             
            } else {
              toast.error(response.data.reason, {
                className: "toast-error-custom",
              });
            }
      return response.data;
    } catch(error) {
      return rejectWithValue(error?.response?.data?.message || "Unable to connect to server");
    }
  })

const updateEmployeeRoleSlice = createSlice({
  name: 'updateEmployeeRole',
  initialState: {
    updateEmployeeRole: {},
    status: 'idle',
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builders) => {
    builders
      .addCase(updateEmployeeRole.pending,
        (state) => {
          state.status = 'loading';
          state.loading = true;
          state.error = null;
        })
      .addCase(updateEmployeeRole.fulfilled,
        (state, action) => {
          state.status = 'succeeded';
          state.loading = false;
          state.updateEmployeeRole = action.payload;
        })
      .addCase(updateEmployeeRole.rejected,
        (state, action) => {
          state.status = 'failed';
          state.loading = false;
          state.error = action.payload;
        }
      )
  }
})

export default updateEmployeeRoleSlice.reducer;